import { render, staticRenderFns } from "./ProduzioneInsit.vue?vue&type=template&id=1dcb037c&scoped=true&"
import script from "./ProduzioneInsit.vue?vue&type=script&lang=js&"
export * from "./ProduzioneInsit.vue?vue&type=script&lang=js&"
import style0 from "./ProduzioneInsit.vue?vue&type=style&index=0&id=1dcb037c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb037c",
  null
  
)

export default component.exports